//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngModalDialog', srsngModalDialog);

    function srsngModalDialog() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/modal-dialog/modal-dialog.html',
            scope: {
                show: '=',               
                onClose: '&',
                fullOverlay: '=?'
            },
            transclude: true,
            controller: controller,
            link: link
        };

        function controller($scope) {
            $scope.$watch('show', function (newVal, oldVal) {
                if (newVal && !oldVal) {
                    document.getElementsByTagName("body")[0].style.overflow = "hidden";
                } else {
                    document.getElementsByTagName("body")[0].style.overflow = "";
                }
                if ((!newVal && oldVal) && ($scope.onClose != null)) {
                    return $scope.onClose();
                }
            });
            
        }

        function link(scope, element, attrs) {
            scope.dialogStyle = {};
            if (attrs.width)
                scope.dialogStyle.width = attrs.width;
            if (attrs.height)
                scope.dialogStyle.height = attrs.height;
        }
    }

})();

